import React from 'react';
import ReactDOM from 'react-dom';
import SMSearchHelper from 'components/helpers/SMSearchHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMMobileSearchFilterView from 'components/header/SMMobileSearchFilterView';

class SMMobileHeaderSearch extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpenFilter: false,
      amenities: props.amenities,
    };
  }

  componentDidMount() {
    if (SMAppHelper.isMobile()) {
      const $fixedHeader = $('#js-site-header__fixed');
      $fixedHeader.sticky({topSpacing:0});
      $fixedHeader.
        on('sticky-start', function() {
          $('.site-main').addClass('site-main__fixed-header');
        }).
        on('sticky-end', function() {
          $('.site-main').removeClass('site-main__fixed-header');
        });
        
      $(document).on('showMobileSearchFilter', (e, originalState)=>{
        this.setState({amenities: originalState.amenities});
        setTimeout(()=>{
          this.toggleSearchFilter();
        }, 10);
      });
    }
  }

  toggleSearchFilter(e) {
    if (e) e.preventDefault();
    const isOpen = !this.state.isOpenFilter;
    this.setState({
      isOpenFilter: isOpen,
    });

    const filterContainer = document.getElementById('js-mobile-search-filter__container');
    if (isOpen) {
      ReactDOM.render(
        <SMMobileSearchFilterView
          eventType={this.props.eventType}
          priceType={this.props.priceType}
          location={this.props.location}
          capacity={this.props.capacity}
          startedAt={this.props.startedAt}
          endedAt={this.props.endedAt}
          stayCheckinAt={this.props.stayCheckinAt}
          stayCheckoutAt={this.props.stayCheckoutAt}
          minPrice={this.props.minPrice}
          maxPrice={this.props.maxPrice}
          minCapacity={this.props.minCapacity}
          maxCapacity={this.props.maxCapacity}
          geocode={this.props.geocode}
          amenities={this.state.amenities}
          keyword={this.props.keyword}
          eventTypeList={this.props.eventTypeList}
          amenityList={this.props.amenityList}
          capacityList={this.props.capacityList}
          delegate={this}
        />,
        filterContainer
      );
    } else {
      ReactDOM.unmountComponentAtNode(filterContainer);
    }
  }

  searchFieldDidFocus(e) {
    e.currentTarget.blur();
  }

  render() {

    const title = SMSearchHelper.formatTitle(this.props, this.props.amenityList);

    return (
      <div className="site-header__search-sm pc-hide__sm-show">
        <div className="sm__site-header__search">
          <div className="sm__site-header__search-bd">
            <div className="site-header__search-input-wrapper">
              <input type="search"
                onFocus={this.searchFieldDidFocus.bind(this)}
                readOnly={true}
                value={title}
                className="site-header__search-input site-header__search-keyword"
                placeholder="何を？ どこで？ いつ？" />
              <a href="#" className="js-mobile-header-search__tranparent"
                onClick={this.toggleSearchFilter.bind(this)}
                 />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default SMMobileHeaderSearch;



// WEBPACK FOOTER //
// ./app/javascript/components/header/SMMobileHeaderSearch.jsx